export default {
      id: "deco-titre-usage",
      viewBox: "0 0 40 16",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco-titre-usage",
      toString: function () {
        return this.url;
      }
    }